import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
import Button, { ButtonIcon, ButtonPresentationProps, ButtonProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Hidden from "@insite/mobius/Hidden";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Minus from "@insite/mobius/Icons/Minus";
import Plus from "@insite/mobius/Icons/Plus";
import Link from "@insite/mobius/Link";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextFieldProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductAlertMessage from "@tCentro/Components/CENProductAlertMessage";
import CENProductDescription from "@tCentro/Components/CENProductDescription";
import ProductFinePrint from "@tCentro/Components/CENProductFinePrintText";
import ProductSpecialMessage from "@tCentro/Components/CENProductSpecialMessage";
import CENCustonWrenchIcon from "@tCentro/Icons/CENCustonWrenchIcon";
import CENErrorIcon from "@tCentro/Icons/CENErrorIcon";
import EllipsisVerticalIcon from "@tCentro/Icons/EllipsisVerticalIcon";
import { ProductAvailabilityStyles } from "@tCentro/Overrides/Components/ProductAvailability";
import ProductQuantityOrdered from "@tCentro/Overrides/Components/ProductQuantityOrdered";
import CustomApplicationState from "@tCentro/Store/CustomApplicationState";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";

import React, { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    showPrice: boolean;
    showAvailability: boolean;
}

const mapStateToProps = (state: ApplicationState & CustomApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
    settingsCollection: getSettingsCollection(state),
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
    isMinErrorObj: state.t_components.isMinError,
    isMultiErrorObj: state.t_components.isMultiError,
});

const mapDispatchToProps = {};

type Props = ReturnType<typeof mapStateToProps> &
    HasProductContext &
    ResolveThunks<typeof mapDispatchToProps> &
    OwnProps;

export interface ProductListActionsStyles {
    subQTYBtn?: ButtonProps;
    addQTYBtn?: ButtonProps;
    errorMsgStyle?: InjectableCss;

    tooltipContainerStyles?: InjectableCss;
    wrapper?: InjectableCss;
    addToCartWrapper?: InjectableCss;
    addToCartButton?: ButtonPresentationProps;
    quantityOrdered?: TextFieldProps;
    quantityOrderedWithError?: TextFieldProps;
    unitOfMeasureSelect?: SelectPresentationProps;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    price?: ProductPriceStyles;
    addToListLink?: ProductAddToListLinkStyles;
    addToListWrapper?: InjectableCss;
    ellipsisVerticalIconWrapper?: InjectableCss;
    ellipsisIconWrapper?: InjectableCss;
    descriptionWrapper?: InjectableCss;
    availabilityGridItem?: InjectableCss;
    availabilityStyles?: ProductAvailabilityStyles;
    moreOptionsStyles?: InjectableCss;
    wrenchIconStyles?: IconPresentationProps;
    configureProductPlpStyles?: InjectableCss;
    errorIconStyles?: IconPresentationProps;
    errorMsgStyleTypo?: TypographyPresentationProps;
}

export const actionsStyles: ProductListActionsStyles = {
    errorMsgStyleTypo: {
        color: "danger",
        css: css`
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
        `,
    },
    errorIconStyles: {
        size: 20,
        css: css`
            span {
                width: 20px;
                height: 20px;
            }
        `,
    },
    errorMsgStyle: {
        css: css`
            display: flex;
            position: absolute;
            bottom: 8px;
            justify-content: center;
            gap: 4px;
            position: absolute;
            margin-top: 6px;
            top: 30px;
        `,
    },
    tooltipContainerStyles: {
        css: css`
            background-color: #262525;
            border-radius: 4px;
            width: max-content;
            border-radius: 4px;
            box-shadow: 0px 4px 8px 0px rgba(38, 37, 37, 0.24);
            position: absolute;
            top: -34px;
            left: -5px;
            z-index: 999;
            font-size: 12px;
            font-style: normal;
            font-weight: 600;
            line-height: 16px;
            padding: 8px 16px;
            color: #262525;
            @media (max-width: 1024px) {
                top: -42px;
                right: 0px;
            }
            &:after {
                content: "";
                border-left: 0px solid ${getProp("theme.typography.p.color")};
                border-right: 4px solid ${getProp("theme.typography.p.color")};
                position: absolute;
                z-index: 999;
                top: 29px;
                left: 42%;
                width: 0px;
                height: 16px;
                width: 0px;
                height: 0px;
                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
                border-top: 16px solid ${getProp("theme.typography.p.color")};
            }
        `,
    },
    addQTYBtn: {
        css: css`
            height: 16px;
            background-color: transparent;
            padding: 0px;
            position: absolute;
            left: 106px;
            margin-bottom: 13px;
            z-index: 1;
            border: none;
            min-height: 16px !important;
            & svg {
                color: ${COLORS.black};
                height: 16px !important;
                width: 16px !important;
                margin-left: 5px;
            }
            &:hover {
                background-color: transparent;
                border: none;
            }
            &:focus {
                outline: none;
            }
            &:disabled,
            &:disabled:hover {
                background: transparent;
            }
            &:active {
                background-color: transparent;
            }
            @media all and (min-width: 1707px) {
                margin-bottom: 14px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        left: 114px;
                    `,
                    css`
                        left: 114px;
                    `,
                    css`
                        left: 124px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    subQTYBtn: {
        css: css`
            height: 16px;
            background-color: transparent;
            padding: 0px;
            position: absolute;
            left: 52px;
            margin-bottom: 13px;
            z-index: 1;
            border: none;
            min-height: 16px !important;
            & svg {
                color: ${COLORS.black};
                height: 16px !important;
                width: 16px !important;
            }
            &:hover {
                background-color: transparent;
                border: none;
            }
            &:focus {
                outline: none;
            }
            &:disabled {
                background-color: transparent;
            }
            &:disabled:hover {
                background-color: transparent;
            }
        `,
    },
    configureProductPlpStyles: {
        css: css`
            font-family: Poppins;
            font-size: 16px;
            font-weight: 600;
            color: ${getProp("theme.typography.p.color")};
            margin-bottom: 15px;
        `,
    },
    moreOptionsStyles: {
        css: css`
            margin-bottom: 8px;
            border: 2px solid ${getColor("primary")};
            padding: 4px 12px 4px 8px;
            border-radius: 16px;
            span {
                font-family: Poppins;
                font-size: 12px;
                font-weight: 600;
                line-height: 16px;
                color: ${getColor("primary")} !important;
                display: flex;
                align-items: center;
                gap: 2px;
            }
        `,
    },
    wrenchIconStyles: {
        size: 16,
    },
    wrapper: {
        css: css`
            display: flex;
            width: 100%;
            flex-direction: column;
        `,
    },
    descriptionWrapper: {
        css: css`
            display: none;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: flex;
                    `,
                    css`
                        display: flex;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    unitOfMeasureSelect: {
        cssOverrides: {
            formField: css`
                margin-top: 8px !important;
                label {
                    font-size: ${TYPOGRAPHY.size.base};
                    line-height: 22px;
                    color: ${getProp("theme.typography.p.color")};
                }
            `,
            formInputWrapper: css`
                margin-top: 6px !important;
                margin-bottom: 5px !important;
            `,
        },
    },
    quantityBreakPricing: {
        viewLink: {
            css: css`
                margin: 8px 0;
            `,
        },
    },
    addToCartWrapper: {
        css: css`
            position: relative;
            display: flex;
            align-items: flex-end;
            button {
                width: auto;
            }
        `,
    },
    addToCartButton: {
        css: css`
            width: 50%;
            border-radius: 16px !important;
            border: 0 !important;
            padding: 8px 16px !important;
            min-height: 32px !important;
            @media all and (min-width: 344px) and (max-width: 360px) {
                padding: 8px 15px !important;
            }
            @media all and (max-width: 768px) {
                width: 150px !important;
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 140px !important;
                    `,
                    css``,
                    css`
                        width: 142px !important;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                margin-right: 8px;
                width: auto;
                flex-direction: row;
                align-items: center;
                label {
                    display: inline-flex;
                    flex: 1;
                    margin-right: 2px;
                    width: 35px;
                    align-items: center;
                    font-weight: ${TYPOGRAPHY.weight.mediumbold};
                    font-size: ${TYPOGRAPHY.size.smaller};
                    line-height: 16px;
                    color: ${getProp("theme.typography.p.color")};
                }
                div {
                    flex: 1;
                    margin-top: 0 !important;
                }
            `,
            formInputWrapper: css`
                input {
                    text-align: center;
                    &::-webkit-outer-spin-button,
                    &::-webkit-inner-spin-button {
                        -webkit-appearance: none;
                        margin: 0;
                    }
                    border: 2px solid ${COLORS.background.grayShade} !important;
                }
                input {
                    &:focus {
                        border-radius: 40px !important;
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            input {
                                width: 112px !important;
                            }
                        `,
                        css`
                            input {
                                width: 112px !important;
                            }
                        `,
                        css`
                            input {
                                width: 125px !important;
                            }
                        `,
                        null,
                        null,
                    ])}
            `,
        },
    },
    quantityOrderedWithError: {
        cssOverrides: {
            formField: css`
                margin-right: 8px;
                width: auto;
                flex-direction: row;
                align-items: center;
                label {
                    display: inline-flex;
                    flex: 1;
                    margin-right: 2px;
                    width: 35px;
                    align-items: center;
                    font-weight: ${TYPOGRAPHY.weight.mediumbold};
                    font-size: ${TYPOGRAPHY.size.smaller};
                    line-height: 16px;
                    color: ${getProp("theme.typography.p.color")};
                }
                div {
                    flex: 1;
                    margin-top: 0 !important;
                }
            `,
            formInputWrapper: css`
                input {
                    text-align: center;
                    &::-webkit-outer-spin-button,
                    &::-webkit-inner-spin-button {
                        -webkit-appearance: none;
                        margin: 0;
                    }
                    border: 2px solid ${COLORS.alertMsgRed} !important;
                }
                input {
                    &:focus {
                        border-radius: 40px !important;
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            input {
                                width: 112px !important;
                            }
                        `,
                        css`
                            input {
                                width: 112px !important;
                            }
                        `,
                        css`
                            input {
                                width: 125px !important;
                            }
                        `,
                        null,
                        null,
                    ])}
            `,
        },
    },
    addToListWrapper: {
        css: css`
            margin-top: 20px;
            min-height: 2rem;
        `,
    },
    price: {
        priceWrapper: {
            css: css`
                div {
                    & > span {
                        font-size: 17px !important;
                        margin-right: 5px;
                    }
                }
                h4 {
                    font-size: 24px !important;
                }
            `,
        },
        wrapper: {
            css: css`
                min-height: 61px;
            `,
        },
    },
    availabilityGridItem: {
        css: css`
            width: 100%;
            div[class^="GridItemStyle"] {
                > div {
                    margin-bottom: 8px;
                }
            }
        `,
    },
    availabilityStyles: {
        messageText: {
            css: css`
                width: 100%;
                font-size: ${TYPOGRAPHY.size.smaller};
                font-weight: ${TYPOGRAPHY.weight.baseBold};
                color: ${getProp("theme.typography.p.color")};
                ${wrapInContainerStyles}
            `,
        },
        availabilityByWarehouseLink: {
            css: css`
                font-size: ${TYPOGRAPHY.size.smaller};
                font-weight: ${TYPOGRAPHY.weight.baseBold};
                line-height: 28px;
            `,
        },
        outOfStockContainerStyles: {
            css: css`
                display: flex;
                align-items: center;
                margin-bottom: 22px;
            `,
        },
    },
};

const styles = actionsStyles;

const ProductListActions: FC<Props> = ({
    productContext,
    productSettings,
    showPrice,
    settingsCollection,
    showAvailability,
    variantSelectionCompleted,
    isMinErrorObj,
    isMultiErrorObj,
}) => {
    const [gridMinErr, setGridMinErr] = useState(false);
    const [gridMultiErr, setGridMultiErr] = useState(false);

    const qtyOrderedFinalStyle =
        gridMinErr || gridMultiErr ? { ...styles.quantityOrderedWithError } : { ...styles.quantityOrdered };

    const [btnQty, setBtnQty] = React.useState(() => {
        if (productContext.productInfo?.qtyOrdered !== undefined && productContext.productInfo?.qtyOrdered !== null) {
            return productContext.productInfo.qtyOrdered;
        }

        if (
            productContext.product?.detail?.multipleSaleQty &&
            productContext.product?.detail?.multipleSaleQty > 0 &&
            productContext.product?.detail?.roundingRule === "Multiple Only"
        ) {
            return productContext.product.detail.multipleSaleQty;
        }
        return 0;
    });
    const [showTooltip, setShowTooltip] = React.useState(false);

    const addQtyFn = () => {
        setBtnQty(
            btnQty +
                (productContext.product?.detail?.multipleSaleQty &&
                productContext.product?.detail?.multipleSaleQty > 0 &&
                productContext.product?.detail?.roundingRule === "Multiple Only"
                    ? productContext.product?.detail?.multipleSaleQty
                    : 1),
        );
    };
    const subQtyFn = () => {
        const qtyValue =
            btnQty -
            (productContext.product?.detail?.multipleSaleQty &&
            productContext.product?.detail?.multipleSaleQty > 0 &&
            productContext.product?.detail?.roundingRule === "Multiple Only"
                ? productContext.product?.detail?.multipleSaleQty
                : 1);
        if (qtyValue === 0 || Math.sign(qtyValue) === -1) {
            setBtnQty(0);
            return false;
        }
        setBtnQty(qtyValue);
    };
    const handleMouseEnter = () => {
        if (
            productContext.product?.detail?.multipleSaleQty &&
            productContext.product?.detail?.multipleSaleQty > 0 &&
            productContext.product?.detail?.roundingRule === "Multiple Only" &&
            btnQty === productContext.product?.detail?.multipleSaleQty
        ) {
            setShowTooltip(true);
        } else {
            setShowTooltip(false);
        }
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };

    React.useEffect(() => {
        const multipleSaleQty = productContext?.product?.detail?.multipleSaleQty;
        const roundingRule = productContext?.product?.detail?.roundingRule;
        const qtyOrdered = productContext?.productInfo?.qtyOrdered;

        if (productContext.productInfo?.qtyOrdered !== undefined && productContext.productInfo?.qtyOrdered !== null) {
            setBtnQty(productContext.productInfo.qtyOrdered);
        }
        if (multipleSaleQty && multipleSaleQty > 0 && roundingRule === "Multiple Only" && qtyOrdered === 1) {
            productContext?.onQtyOrderedChanged?.(multipleSaleQty);

            setBtnQty(multipleSaleQty);
        }
    }, [productContext.productInfo?.qtyOrdered]);

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.descriptionWrapper}>
                <CENProductDescription product={productContext} />
            </StyledWrapper>
            {showPrice && !productContext?.product?.isVariantParent ? (
                <>
                    <ProductPrice
                        product={productContext}
                        showLabel={false}
                        showSavings={true}
                        showSavingsAmount={productSettings.showSavingsAmount}
                        showSavingsPercent={productSettings.showSavingsPercent}
                        extendedStyles={styles.price}
                    />
                    <ProductQuantityBreakPricing extendedStyles={styles.quantityBreakPricing} />
                </>
            ) : (
                <Hidden above="sm">
                    <Link href={productContext.product?.canonicalUrl} {...styles.moreOptionsStyles}>
                        <Icon src={CENCustonWrenchIcon} {...styles.wrenchIconStyles} />
                        {translate("Configure Product")}
                    </Link>
                    <Typography as="p" {...styles.configureProductPlpStyles}>
                        {siteMessage("configureProduct_Plp_Msg")}
                    </Typography>
                </Hidden>
            )}
            {settingsCollection.productSettings.showInventoryAvailability && showAvailability && (
                <StyledWrapper {...styles.availabilityGridItem}>
                    <ProductContextAvailability extendedStyles={styles.availabilityStyles} />
                </StyledWrapper>
            )}
            <ProductUnitOfMeasureSelect extendedStyles={styles.unitOfMeasureSelect} />

            {productContext.product.properties.specialMessage && (
                <ProductSpecialMessage specialMessage={productContext.product.properties.specialMessage} />
            )}
            {productContext.product.properties.alertMessage && (
                <ProductAlertMessage alertMessage={productContext.product.properties.alertMessage} />
            )}

            {productContext.product.properties.finePrint && (
                <ProductFinePrint finePrint={productContext.product.properties.finePrint} />
            )}

            <StyledWrapper {...styles.addToCartWrapper}>
                <Button
                    disabled={
                        !!(
                            (!variantSelectionCompleted && productContext.product?.isVariantParent) ||
                            (productContext.product?.detail?.multipleSaleQty &&
                                productContext.product?.detail?.multipleSaleQty > 0 &&
                                productContext.product?.detail?.roundingRule === "Multiple Only" &&
                                btnQty === productContext.product?.detail?.multipleSaleQty)
                        )
                    }
                    {...styles.subQTYBtn}
                    data-test-selector="subQTYBtn"
                    onClick={subQtyFn}
                    onMouseOver={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    <ButtonIcon src={Minus} />
                </Button>
                {showTooltip && (
                    <StyledWrapper {...styles.tooltipContainerStyles}>
                        <Typography
                            as="span"
                            css={css`
                                color: ${getColor("info.contrast")} !important;
                            `}
                        >
                            {translate(`${productContext.product?.detail?.multipleSaleQty} unit minimum`)}
                        </Typography>
                    </StyledWrapper>
                )}
                <ProductQuantityOrdered
                    onBtnclickQtyValue={btnQty}
                    setBtnQty={setBtnQty}
                    extendedStyles={qtyOrderedFinalStyle}
                    setGMinErr={setGridMinErr}
                    setGMultiErr={setGridMultiErr}
                />
                <Button
                    disabled={!variantSelectionCompleted && productContext.product?.isVariantParent}
                    {...styles.addQTYBtn}
                    data-test-selector="addQTYBtn"
                    onClick={addQtyFn}
                >
                    <ButtonIcon src={Plus} />
                </Button>
                {gridMultiErr === true && (
                    <StyledWrapper {...styles.errorMsgStyle}>
                        <Icon {...styles.errorIconStyles} src={CENErrorIcon} />
                        <Typography {...styles.errorMsgStyleTypo}>
                            {translate(
                                `This product must be ordered in multiples of ${productContext.product?.detail?.multipleSaleQty}`,
                            )}
                        </Typography>
                    </StyledWrapper>
                )}
                {gridMinErr === true && (
                    <StyledWrapper {...styles.errorMsgStyle}>
                        <Icon {...styles.errorIconStyles} src={CENErrorIcon} />
                        <Typography {...styles.errorMsgStyleTypo}>
                            {translate(
                                `This product has a minimum order of ${productContext.product?.detail?.multipleSaleQty} units`,
                            )}
                        </Typography>
                    </StyledWrapper>
                )}

                <ProductAddToCartButton
                    data-test-selector={`actionsAddToCart${productContext.product.id}`}
                    extendedStyles={styles.addToCartButton}
                />
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withProductContext(ProductListActions));
